import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout';
import './Round.css';

const CLUES = [
  { scrambled: 'YDIA', answer: 'DIYA' },
  { scrambled: 'OALMDGRI', answer: 'MARIGOLD' },
  { scrambled: 'LTENANR', answer: 'LANTERN' },
  { scrambled: 'ONRALIG', answer: 'RANGOLI' },
  { scrambled: 'FELROWS', answer: 'FLOWERS' },
];

export default function Unscramble() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isDemo = user?.role === 'demobypass';
  const [revealed, setRevealed] = useState(false);

  const handleNext = () => {
    if (!isDemo) {
      navigate('/round-2');
      return;
    }
    // Demo sessions get a single round, then are upsold to subscribe.
    Swal.fire({
      title: 'Thank you for playing!',
      text: 'Thank you for playing. Subscribe to any PLAN to play with your peers.',
      icon: 'info',
      confirmButtonText: 'View Plans',
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(() => {
      window.location.href = (process.env.REACT_APP_BASE_URL || '') + '/plans';
    });
  };

  return (
    <Layout round="Round 1" title="Unscramble Words" subtitle="(Identify festive decorative items)">
      <div className="clue-columns">
        <div className="clue-col">
          {CLUES.map((c, idx) => (
            <p key={idx} className="clue-item">
              {idx + 1}. {c.scrambled}
            </p>
          ))}
        </div>
        <div className="clue-col">
          {CLUES.map((c, idx) => (
            <p key={idx} className={`clue-answer ${revealed ? 'revealed' : ''}`}>
              {c.answer}
            </p>
          ))}
        </div>
      </div>

      {!revealed ? (
        <button className="hunt-btn" onClick={() => setRevealed(true)}>
          Reveal Answer
        </button>
      ) : (
        <button className="hunt-btn" onClick={handleNext}>
          Next
        </button>
      )}
    </Layout>
  );
}
